import Style from './index.module.less'
import DiscordIcon from '@/assets/image/gea/discord.svg'
import LinkedinIcon from '@/assets/image/gea/linkedin.svg'
import MediumIcon from '@/assets/image/gea/medium.svg'
import MirrorIcon from '@/assets/image/gea/mirror.svg'
import TelegramIcon from '@/assets/image/gea/Telegram.svg'
import XtwitterIcon from '@/assets/image/gea/xtwitter.svg'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface footerConfigItem {
  title: string
  list: {
    logo: string
    text: string
    link?: string
    key?: string
  }[]
}
const Footer = () => {
  const { t } = useTranslation()
  const footerConfig: footerConfigItem[] = [
    {
      // 解决方案
      title: t('explorer_27'),
      list: [
        {
          logo: '',
          text: 'GEA NetWork',
        },
      ],
    },
    {
      // 生态
      title: t('explorer_28'),
      list: [
        {
          // 区块链浏览器
          logo: '',
          key: 'home',
          text: t('explorer_31'),
        },
        {
          // 地址公示
          logo: '',
          text: t('explorer_32'),
          key: 'addressPublicity',
          link: 'addressPublicity',
        },
        {
          // 小程序
          logo: '',
          text: t('explorer_33'),
        },
        {
          // 插件钱包
          logo: '',
          text: t('explorer_34'),
        },
      ],
    },
    // {
    //   // 社区
    //   title: t('explorer_29'),
    //   list: [
    //     {
    //       logo: XtwitterIcon,
    //       text: 'Twitter',
    //     },
    //     {
    //       logo: DiscordIcon,
    //       text: 'Discord',
    //     },
    //     {
    //       logo: TelegramIcon,
    //       text: 'Telegram',
    //     },
    //     {
    //       logo: MirrorIcon,
    //       text: 'Mirror',
    //     },
    //     {
    //       logo: MediumIcon,
    //       text: 'Medium',
    //     },
    //     {
    //       logo: LinkedinIcon,
    //       text: 'Linkedln',
    //     },
    //   ],
    // },
    {
      // 关于
      title: t('explorer_30'),
      list: [
        {
          logo: '',
          key: 'GeaFoundation',
          text: 'GEA Foundation',
        },
        {
          // 团队
          logo: '',
          key: 'team',
          text: t('explorer_36'),
        },
        // {
        //   // 常见问题
        //   logo: '',
        //   text: t('explorer_37'),
        // },
      ],
    },
  ]

  const listNew = [
    {
      // 区块链浏览器
      logo: '',
      key: 'home',
      text: t('explorer_31'),
    },
    {
      // 地址公示
      logo: '',
      text: t('explorer_32'),
      key: 'addressPublicity',
      link: 'addressPublicity',
    },
    {
      // 小程序
      logo: '',
      key: 'APP',
      text: t('explorer_33'),
    },
    // {
    //   // 插件钱包
    //   logo: '',
    //   key: 'wallet',
    //   text: t('explorer_34'),
    // },
  ]

  const navigate = useMeNavigate()

  const handleAddressJump = (item: any) => {
    if (item.key === 'home') {
      if (location.pathname.includes('home')) return
      navigate('/home')
    }
    if (item.key === 'addressPublicity') {
      if (location.pathname.includes('addressPublicity')) return
      navigate('/addressPublicity')
    }
    if (item.key === 'GeaFoundation') {
      window.open(import.meta.env.VITE_FOUNDATION_URL, '_blank')
    }
    if (item.key === 'team') {
      window.open(import.meta.env.VITE_FOUNDATION_URL + '/team', '_blank')
    }
    if (item.key === 'APP') {
      window.open(import.meta.env.VITE_INVITE_URL + '/download', '_blank')
    }
    if (item.key === 'wallet') {
      window.open(import.meta.env.VITE_WALLET_URL, '_blank')
    }
  }
  return (
    // <div className={Style.wrap}>
    //   <div>
    //     {footerConfig.map((item, itemIndex) => {
    //       return (
    //         <div className={Style.item} key={itemIndex}>
    //           <div className={Style.title}>{item.title}</div>
    //           {item.list.map((listItem, index) => {
    //             return (
    //               <div className={Style.titleList} key={index}>
    //                 {listItem.logo && <img src={listItem.logo} alt="" />}
    //                 <span onClick={() => handleAddressJump(listItem)}>{listItem.text}</span>
    //               </div>
    //             )
    //           })}
    //         </div>
    //       )
    //     })}
    //   </div>
    // </div>
    <div className={Style.wrap}>
      <div className={Style.title}>{t('explorer_28')}</div>
      <div>
        {listNew.map((item, index) => {
          return (
            <div className={Style.titleList} key={index} onClick={() => handleAddressJump(item)}>
              {item.text}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Footer
